import {useState} from 'react';
import './App.css'; 
import {db} from './firebaseconfig.js';
import {doc,updateDoc} from 'firebase/firestore';  
function Updatecomp(props){
         const note=props.note;
         const title=props.title;  
         const [Title,SetTitle]=useState(title);  
         const [Note,SetNote]=useState(note);     
         let Id=props.id;
         let Notes=props.notes;
         let SetNotes=props.setnotes;  
         var docname=props.docname; 
         let SetCase=props.setcase;  
         const Add=()=>{
               let obj={Title:Title,Note:Note};  
               if(Title!=null&&Note!=null)  
               {
                  Notes[Id]=obj;
                  SetNotes(Notes);
                  let docref=doc(db,"Notes",docname);
                  updateDoc(docref,obj);  
                  SetTitle('');
                  SetNote('');  
                  SetCase('mainpage');  
               }  
         }
         return (
            <div className="div">
                 <input type="text" className="inp-title" onChange={(e)=>{SetTitle(e.target.value)}} placeholder="Title" maxLength={30} value={Title}></input>   
                 <textarea type="text" className="inp-note" value={Note} onChange={(e)=>{SetNote(e.target.value)}}maxLength={700} placeholder="Note" ></textarea>  
                 <button className="save-button" onClick={Add}>Update</button>  
            </div>    
         );
}
export default Updatecomp;